import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import DealStatusContextProvider from '@/creditflowresearch/application/Deal/contexts/DealStatusContext';
import ProductsContextProvider from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import { DealTooltipProvider } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import { RowsExpandedProvider } from '@/creditflowresearch/application/Deal/contexts/RowsExpandedContext';
import { TFilterPayload } from '@/creditflowresearch/application/League/Scorecard/types';
import { getDealsByActiveProduct } from '@/creditflowresearch/application/Deal/helpers/getDealsByActiveProduct';
import { IDealsPayload } from '@/creditflowresearch/domain/vo/IDeal';

export interface ITileWrapperProps {
  children?: React.ReactNode,
  requiredUserPlan?: UserPlanType,
  additionalFilters?: TFilterPayload,
}

export const withTileContext = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const WithTileContext: React.FC<P & ITileWrapperProps> = (props) => {
    const { deals, availableProductIds, activeProductId } = useParentPageContext();
    const productDeals = getDealsByActiveProduct(deals, activeProductId);

    return (
      <DealStatusContextProvider filters={ productDeals?.pageFilters?.filters as unknown as IDealsPayload['filters'] }>
        <ProductsContextProvider availableProductIds={ availableProductIds }>
          <DealTooltipProvider>
            <RowsExpandedProvider>
              <Component { ...props as P } />
            </RowsExpandedProvider>
          </DealTooltipProvider>
        </ProductsContextProvider>
      </DealStatusContextProvider>
    );
  };

  return WithTileContext;
};
